<template>
  <div class="equipmentManagement-page">
    <div class="all-content-container">
      <el-tabs :tab-position="tabPosition" style="height: 200px" v-model="activeName2">
        <el-tab-pane label="实时告警数据" name="pane3">
          <alarmLog></alarmLog>
        </el-tab-pane>
        <el-tab-pane label="设备告警配置" name="pane1">
          <alarmTemplate></alarmTemplate>
        </el-tab-pane>
        <!-- <el-tab-pane label="设备告警配置" name="pane2">
          <alarmConfiguration></alarmConfiguration>
        </el-tab-pane> -->

      </el-tabs>
    </div>
  </div>
</template>
<script>
import alarmTemplate from '../alarmPrediction/alarmTemplate'
import alarmConfiguration from '../alarmPrediction/alarmConfiguration'
import alarmLog from '../alarmPrediction/alarmLog'

export default {
  props: {
    message: {
      type: String,
      default: 'pane1'
    }
  },
  components: {
    alarmTemplate,
    alarmConfiguration,
    alarmLog
  },
  data() {
    return {
      tabPosition: 'left',
      activeName2: 'pane1'
    }
  },
  created() {
    this.activeName2 = this.message
    this.$forceUpdate()
  }
}
</script>
<style lang="scss">
@import '@/style/equipmentManagement.scss';
</style>